/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 */

import {
  CAROUSEL_ORIGINS,
  DETAIL_INLINE_ORIGINS,
  DETAIL_STICKY_ORIGINS,
  FLOORPLAN_ORIGINS,
  FormattedOrigin,
  LIST_ORIGINS,
  Origin,
} from '@zcode/nr-utils'

import type { SaveSearchOrigin } from '../../../modules/savedSearchesView/thunks/createSearch/getOrigin'

export type MixpanelOrigin =
  | Origin
  | SaveSearchOrigin
  | 'Tour Booking'
  | 'Detail Image'
  | 'Detail Video'
  | 'Detail Tour'
  | 'booknow'
  | 'pin'

function getDefinedFormattedOrigin(origin: MixpanelOrigin) {
  if (origin === Origin.DETAIL_AGENT_BOX || origin === Origin.ADDR_DETAIL_AGENT_BOX) {
    return FormattedOrigin.DETAIL_AGENT
  }
  if (origin === Origin.MAP) {
    return FormattedOrigin.MAP
  }
  if ((LIST_ORIGINS as readonly MixpanelOrigin[]).includes(origin)) {
    return FormattedOrigin.LIST
  }
  if ((DETAIL_INLINE_ORIGINS as readonly MixpanelOrigin[]).includes(origin)) {
    return FormattedOrigin.DETAIL_INLINE
  }
  if ((DETAIL_STICKY_ORIGINS as readonly MixpanelOrigin[]).includes(origin)) {
    return FormattedOrigin.DETAIL_STICKY
  }
  if ((CAROUSEL_ORIGINS as readonly MixpanelOrigin[]).includes(origin)) {
    return FormattedOrigin.CAROUSEL
  }
  if ((FLOORPLAN_ORIGINS as readonly MixpanelOrigin[]).includes(origin)) {
    return FormattedOrigin.DETAIL_FLOORPLAN
  }

  return origin
}

export function getFormattedOrigin(origin: undefined): undefined
export function getFormattedOrigin(
  origin: MixpanelOrigin
): ReturnType<typeof getDefinedFormattedOrigin>
export function getFormattedOrigin(
  origin: MixpanelOrigin | undefined
): undefined | ReturnType<typeof getDefinedFormattedOrigin>
export function getFormattedOrigin(origin: MixpanelOrigin | undefined) {
  if (origin === undefined) {
    return undefined
  }
  return getDefinedFormattedOrigin(origin)
}
